
import { ModalController, ViewController,NavParams } from 'ionic-angular';

import { Component } from '@angular/core';
import { NavController, AlertController, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { UploadService } from '../../../services/upload-service';
import { Upload } from '../../../services/upload';

declare var cordova: any;

import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import { UiData } from "../../../providers/ui-data";
import { JobDataService } from '../../../providers/job-data';

import { SearchPipe } from '../../../pipes/search/search';

import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ProgressBarComponent } from '../../../components/progress-bar/progress-bar';
import * as firebase from "firebase";

import { File } from '@ionic-native/file';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';

@Component({
    selector: 'page-documentselect',
    templateUrl: 'document-select.html'
})
export class DocumentSelectForm {

    lastImage: string = null;

    term: any;
    jobList: any;
    loading: Loading;
    currently_loading: any = false;
    uploadTask: any;
    document_type: any;
    document_id: any;
    file_extensions : string = ".png, .jpg, .jpeg, .doc, .docx, .pdf, .rtf, .odt";
    allowed_file_type : any = "application/pdf , image/* , application/msword , application/vnd.openxmlformats-officedocument.wordprocessingml.document , application/vnd.oasis.opendocument.text";//"document/*, text/*";//"image/*, .pdf, .docx, .doc";
    nativeMode:any = false;
    base64Image: any = "";
    hideCamera: boolean = false;

    multiple_available:any = false;
    isAndroid:any = false;

    constructor(
        public storage: Storage,
        public viewCtrl: ViewController,
        public params: NavParams,
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public navCtrl: NavController,
        private camera: Camera,
        public actionSheetCtrl: ActionSheetController,
        public toastCtrl: ToastController,
        public platform: Platform,
        public loadingCtrl: LoadingController,
        public uploadService: UploadService,
        public file: File,
        public fileTransfer: FileTransfer

    ) {
        this.isAndroid = this.platform.is('android');
        //this.jobList = this.uiData.jobList();
        this.document_type=params.get('document_type');
        this.document_id=params.get('id');
        this.multiple_available=params.get('multiple');

        if(params.get('hideCamera')==true)this.hideCamera=true;
        if(params.get('fileExtensions') && params.get('allowFileTypes'))
        {
            this.file_extensions=params.get('fileExtensions');
            this.allowed_file_type=params.get('allowFileTypes');
        }
        if(this.isAndroid)this.allowed_file_type="*/*";
        if(!this.document_type)this.document_type="others";

        if(!this.document_id)this.document_id=this.document_type;
        else this.document_id = this.document_type+'-'+this.document_id;

        if(platform.is('ios') || platform.is('android') || platform.is('cordova')  )
        {
            this.nativeMode = true
        }
        if(this.uiData.isWebVersion())
        {
            this.hideCamera=true;
        }

    }
    public onFileFromStorageClick(filesEvent: any) {
    }
    public onFileFromStorageChosen(filesEvent: any) {
        this.processFileFromStorage(filesEvent);
    }
    public processFileFromStorage(event: any) {
        let file = event.target.files[0];
        //you can read various properties of the file (like mimetype and size) from the file object.
        var exts = file.name.toLowerCase().split('.');
        var ext = exts[exts.length-1];
        if(this.file_extensions.toLowerCase().indexOf("."+ext)==-1)
        {
            let prompt = this.alertCtrl.create({
                title: 'Format de fichier non autorisé',
                message: 'Les fichiers autorisés sont : '+this.file_extensions
            });
            prompt.present();
        }
        else
        {
            this.readfile(file);
        }
    }
    public readfile(file: any): void {

        this.uploadTask = new Upload(file);
        this.uploadTask.document_type = this.document_id;
        var that = this;
        this.uploadService.pushUpload(this.uploadTask).on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot: any) =>  {
            },
            (error) => {
            },
            () => {
                if(!this.multiple_available) {
                    this.dismissMessage();
                }
                else
                {
                    var that = this;
                    let prompt = this.alertCtrl.create({
                        title: 'Un autre fichier ?',
                        message: "Avez vous un deuxième document à fournir, par exemple le coté verso ?",
                        buttons: [
                            {
                                text: "Oui",
                                handler: data => {
                                    that.multiple_available=false;
                                    that.document_id=that.document_id+'_2';
                                    that.uploadTask=false;
                                }
                            },
                            {
                                text: "Non",
                                handler: data => {
                                    that.dismissMessage();
                                }
                            }
                        ]
                    });
                    prompt.present();
                }
            }
        );

    }
    takePicture(cam=true,front=false){
        var options;
        if(cam) {
            options = {
                destinationType: this.camera.DestinationType.DATA_URL,
                encodingType: this.camera.EncodingType.JPEG,
                mediaType: this.camera.MediaType.PICTURE,
                targetHeight: 1200,
                targetWidth: 1200
            };
        }
        else
        {
            options = {
                destinationType: this.camera.DestinationType.DATA_URL,
                encodingType: this.camera.EncodingType.JPEG,
                mediaType: this.camera.MediaType.PICTURE,
                targetHeight: 1200,
                targetWidth: 1200,
                sourceType:0
            };
        }
        if(front || this.document_id == "avatar")
            options.cameraDirection = this.camera.Direction.FRONT;

        if(this.document_id == "avatar")
        {
            options.allowEdit = true;
            options.correctOrientation = true;
        }

        this.camera.getPicture(options).then((imageData) => {
            // imageData is a base64 encoded string
            this.base64Image = "data:image/jpeg;base64," + imageData;

            this.uploadTask = new Upload(null);
            this.uploadTask.b64 = this.base64Image;
            this.uploadTask.document_type = this.document_id;
            var that = this;
            this.uploadService.pushAsString(this.userData.token+'-'+this.document_id+'.jpg',this.uploadTask).on(firebase.storage.TaskEvent.STATE_CHANGED,
                (snapshot: any) =>  {
                },
                (error) => {
                },
                () => {
                    if(!this.multiple_available) {
                        this.dismissMessage();
                    }
                    else
                    {
                        var that = this;
                        let prompt = this.alertCtrl.create({
                            title: 'Une autre photo ?',
                            message: "Avez vous un deuxième document à fournir, par exemple le coté verso ?",
                            buttons: [
                                {
                                    text: "Oui",
                                    handler: data => {
                                        that.multiple_available=false;
                                        that.document_id=that.document_id+'_2';
                                        that.uploadTask=false;
                                    }
                                },
                                {
                                    text: "Non",
                                    handler: data => {
                                        that.dismissMessage();
                                    }
                                }
                            ]
                        });
                        prompt.present();
                    }
                }
            );
        }, (err) => {
            //console.log(err);
        });
    }

    private dismissMessage()
    {
        var that = this;
        let prompt = this.alertCtrl.create({
            title: 'Validation des documents',
            message: "Les documents envoyés seront vérifiés et certifiés conformes par nos équipes.",
            buttons: [
                {
                    text: "J'ai compris",
                    handler: data => {
                        that.dismiss();
                    }
                }
            ]
        });
        prompt.present();
    }
    private presentToast(text) {
        let toast = this.toastCtrl.create({
            message: text,
            duration: 3000,
            position: 'top'
        });
        toast.present();
    }

    ngAfterViewInit() {

    }
    dismiss() {
        this.viewCtrl.dismiss(this.uploadTask);
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/utils/document-select/document-select.ts